import { signUpThunk } from 'modules/users/sign_up'
import { signInThunk } from 'modules/users/sessions'
import { signOutThunk } from 'modules/users/sign_out'

export default store => next => action => {
  if (!action) return next(action)

  if (
    action.payload &&
    action.payload.status === 401 &&
    action.type !== signUpThunk.FAILED &&
    action.type !== signInThunk.FAILED &&
    action.type !== signOutThunk.FAILED
  ) {
    store.dispatch(signOutThunk())
  }

  return next(action)
}



// WEBPACK FOOTER //
// ./src/core/api/middleware.js